import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ICommentData } from '../../buyer/buyer-dashboard/tenders/tender-details/comments/comments.component';
import * as sparkmd5 from 'spark-md5';
import { QUOTATION_ATTACHMENT_MODAL_STYLE } from 'src/app/constants';
import { AuthService } from '../../../services/auth.service';
import {ProfileService} from "../../../services/profile.service";

@Component({
  selector: 'app-comment-product-details',
  templateUrl: './comment-product-details.component.html',
  styleUrls: ['./comment-product-details.component.scss']
})
export class CommentProductDetailsComponent implements OnInit, OnChanges {

  @Input() selectedProduct: any;
  @Input() attachments: any;
  @Output() downloadTenderAttachment = new EventEmitter();
  @Output() downloadComment = new EventEmitter();
  @Input() stickyComments: any;
  currentLanguage: string;
  filterStickyComments = [];

	tenderAttachmentsModalVisible = false;
	tenderAttachmentsModalStyle = QUOTATION_ATTACHMENT_MODAL_STYLE;

	listOfAttachmentColumn = [
		{
			title: 'global.common.table_title.name',
			width: '70%'
		},
		{
			title: 'global.common.table_title.size',
			width: '10%'
		},
		{
			title: 'global.common.table_title.actions',
			width: '10%'
		}
	];
  //tenderAttachments = [];
  userType: string = '';

  constructor(
    private translateService: TranslateService,
	private profileService: ProfileService
  ) {
    this.currentLanguage = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe(response => {
      if (response) {
        this.currentLanguage = response.lang;
      }
    });
  }

  ngOnInit(): void {
	  this.userType = this.profileService.profileType
  }

  ngOnChanges() {
    this.filterStickyComments = [];
    if (this.stickyComments.length > 0) {
      this.getStickyCommentList(this.stickyComments);
    }
  }

    /**
   * Generate hash code using md5
   */
     generateHash(email: string): void {
      return sparkmd5.hash(email);
    }

  getStickyCommentList(comments): void {

    comments.forEach(comment => {
      const uniqueId = comment.supplier.id ? comment.supplier.id : comment.buyer.id
      const hash = this.generateHash(uniqueId);
      const commentData: ICommentData = {
        id: comment.id,
        avatar: `https://www.gravatar.com/avatar/${hash}?d=identicon`,
        sentBy: comment.supplier.id ? 'supplier' : 'buyer',
        author: this.getCommentAuthor(comment),
        content: comment.text,
        sentOn: moment(comment.sentOn).format('DD.MM.YYYY - HH:mm'),
        attachments: comment.attachments
      }
      this.filterStickyComments.push(commentData)
    });
  }

  onDownloadTender(attachment) {
    this.downloadTenderAttachment.emit(attachment);
  }

  onDownloadComments(threadId, commentId, attachment) {
    const data = {
      threadId,
      commentId,
      attachment
    }
    this.downloadComment.emit(data);
  }

  getName = (name: string) => {

    const length = name.length;
    if (length > 50) {
      let item1 = name.slice(0, 50);
      let item2 = name.slice(50);
      const index = item2.indexOf(' ');
      item2 = index > 0 ? item2.slice(0, index).concat('...') : item2
      name = item1.concat(item2);
    }
    return name;
  }

  getCommentAuthor(comment) {
	if (comment.supplier.id) {
		const author = (comment.supplier?.firstName && comment.supplier?.lastName) ? `${comment.supplier.firstName} ${comment.supplier.lastName}` : comment.supplier.email;
	return  `${comment.supplier.organizationName} (${author})`;
	}

	const author = (comment.buyer?.firstName && comment.buyer?.lastName) ? `${comment.buyer.firstName} ${comment.buyer.lastName}` : comment.buyer.email;
	return  `${comment.buyer.organizationName} (${author})`;
  }

	/**
	 * Display and close tender attachments modal
	 */
	tenderAttachments(showModal: boolean): void {
		this.tenderAttachmentsModalVisible = showModal;
	}
}
